/**
 * Helper to handle chunk loading errors that occur when users have cached old code
 * and the app tries to load new dynamically imported modules after a deployment.
 */

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|Loading chunk \d+ failed|Loading chunk \d+ failed\.|Loading chunk [\w-]+ failed|Loading CSS chunk \d+ failed|ChunkLoadError: Loading chunk \d+ failed|ChunkLoadError: Missing chunk \d+|error loading dynamically imported module|Importing a module script failed|Failed to load module script|Module script failed to load because of a disallowed MIME type|text\/html' is not a valid JavaScript MIME type/i;
const CHUNK_ERROR_REDIRECT_KEY = 'chunk-error-redirect';

/**
 * Checks if an error message is a chunk loading error
 */
export function isChunkLoadError(errorMessage: string): boolean {
  return CHUNK_ERROR_PATTERN.test(errorMessage);
}

export function setChunkErrorRedirect(targetPath: string): void {
  sessionStorage.setItem(CHUNK_ERROR_REDIRECT_KEY, targetPath);
}

export function clearChunkErrorRedirect(): void {
  sessionStorage.removeItem(CHUNK_ERROR_REDIRECT_KEY);
}

export function getChunkErrorRedirect(): string | null {
  return sessionStorage.getItem(CHUNK_ERROR_REDIRECT_KEY);
}

/**
 * Shows an update notification toast and waits for user to click Reload button
 * Falls back to immediate reload if toast is not available
 */
export function handleChunkLoadError(targetPath?: string): void {
  const redirectPath = targetPath || getChunkErrorRedirect();

  if (redirectPath) {
    sessionStorage.removeItem(CHUNK_ERROR_REDIRECT_KEY);
    window.location.href = redirectPath;
    return;
  }

  window.location.reload();
}
